export default "__VITE_ASSET__BzcajHsV__"